import React, { Component } from 'react';
import Sidebartop from '../sidebartop/sidebartop';
import Contactform from '../contactform/contactform';
import { connect } from 'react-redux';
import './contact.css';
import get from 'lodash.get';
import has from 'lodash.has';
import {Helmet} from "react-helmet";

class Contact extends Component {
    componentDidMount() {
        window.scrollTo(0,0);
    }

    render() {
        return (
            <div className="contact">
                <Helmet>
                    <title>Contact - KWOOT</title>
                    <meta property="og:title" content={"Contact - KWOOT"} />
                </Helmet>
                <div className="sidebar">
                    <Sidebartop title="Contact" description={ get(this.props, 'pageOptions.sidebar_description', '') } image={get(this.props, 'pageOptions.sidebar.sidebar_afbeelding.sizes.large','')}/>
                    <div className="sidebar__bottom">
                        <div className="sidebar__bottomwrapper" dangerouslySetInnerHTML={{__html: get(this.props, 'pageOptions.sidebar.sidebar_description', '')}} />
                        <div className="sidebar__bottomthingy" dangerouslySetInnerHTML={{__html: get(this.props, 'pageOptions.quote.post_content', '')}}/>
                    </div>
                </div>
                <div className="contact__content">
                    <div className="contact__form">
                        < Contactform />
                    </div>
                    <div className="contact__blockbottom">
                        <div className="adressen">
                            <div className="adres"><h2 dangerouslySetInnerHTML={{__html: get(this.props, 'pageOptions.adres.twee.post_title', '')}}/><div dangerouslySetInnerHTML={{__html: get(this.props, 'pageOptions.adres.twee.post_content', '')}}></div></div>
                            <div className="adres"><h2 dangerouslySetInnerHTML={{__html: get(this.props, 'pageOptions.adres.een.post_title', '')}}/><div dangerouslySetInnerHTML={{__html: get(this.props, 'pageOptions.adres.een.post_content', '')}}></div></div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (store) => {

    let pageOptions = {};

    if (has(store, 'site.options.page.contact')) {
        pageOptions = get(store, 'site.options.page.contact');
    }

    return {
        pageOptions: pageOptions
    }
}

export default connect(mapStateToProps)(Contact);



// WEBPACK FOOTER //
// ./src/components/contact/contact.js